var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"info-text"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"variant-icon"},[(_vm.variant == 'info')?_c('div',{staticClass:"icon-info"}):(_vm.variant == 'help')?_c('div',{staticClass:"icon-help"}):(_vm.variant == 'legal')?_c('div',{staticClass:"icon-book-open"}):_vm._e()])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20b52fbb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/98_ui/TextBox.vue
// module id = null
// module chunks = 